// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"ContentFeedField_mainContainer__2Lf5z","fileDropContainer":"ContentFeedField_fileDropContainer__MbzGj","fileDropLink":"ContentFeedField_fileDropLink__i6FKu"};